function isDateWithinLast30Days(targetDate) {
    const now = new Date(); // Current date and time
    // Calculate the date 30 days ago
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(now.getDate() - 30);

    // Compare the timestamps (numeric values of the dates)
    // The target date is within the last 30 days if it's after the 30-day-ago mark
    // and not in the future relative to 'now' (optional, depending on requirements)
    return targetDate >= thirtyDaysAgo && targetDate <= now;
}

export default isDateWithinLast30Days